/*
 注：
 (1)、如需允许其他联接方式，可以修改“(ht|f)tps?”部分，在“?”后面跟上符号“|”，然后加上您需要的联接方式，多个时用符号“|”分隔)。
 (2)、如需允许URL参数包含其它字符，可以修改“[\w\-\.,@?^=%&:\/~\+#]”，以设置您需要的参数。
 */
const match = /^((ht|f)tps?:)\/\/([\w-]+(\.[\w-]+)*\/){1}(([\w-]+(\.[\w-]+)*\/?)*)?(\?([\w\-.,@?^=%&:/~+#]*)+)?$/;

export default function parseUrl(url) {
    return match.exec(url);
}
